import { createSlice } from "@reduxjs/toolkit";
import { similarNonprofitsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const similarNonprofitSlice = createSlice({
  name: "similarNonprofit",
  initialState: data,
  reducers: {
    similarNonprofitSlice(state) {
      state.isLoading = false;
    },
    similarNonprofitSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    similarNonprofitSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    similarNonprofitSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const similarNonprofitHandler = () => async (dispatch: any) => {
  try {
    dispatch(similarNonprofitAction.similarNonprofitSlice());
    const response: any = await similarNonprofitsAPI();
    dispatch(similarNonprofitAction.similarNonprofitSliceSuccess(response));
  } catch (e: any) {
    dispatch(similarNonprofitAction.similarNonprofitSliceFailure(e?.response?.data?.message));
    dispatch(similarNonprofitAction.similarNonprofitSliceReset());
  }
};
export default similarNonprofitSlice.reducer;
export const similarNonprofitAction = similarNonprofitSlice.actions;
